import { css } from '@emotion/react';

import { theme } from 'global';

export const link = css`
  display: contents;
  font-size: inherit !important;
  font-weight: inherit !important;
  vertical-align: unset;
`;

const fieldHelperText = css`
  display: flex;
  align-items: baseline;
  margin: 4px 0 0 0 !important;
  color: ${theme.colors.danger};

  .errorIcon {
    width: 1rem;
    height: 1rem;
    flex-shrink: 0;
    position: relative;
    top: 3px;
    margin-right: 4px;
    fill: ${theme.colors.danger};
  }
`;

export const helperText = css`
  > .MuiFormHelperText-root {
    margin-bottom: -20px;
    color: ${theme.colors.neutral[500]};

    &.Mui-error {
      ${fieldHelperText};
      margin-bottom: -20px;
    }
  }
`;

export const manualAddressRoot = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 12px;
`;

export const manualAddressFields = css`
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr;

  @media screen and (min-width: ${theme.breaks.sm}px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const textfield = css`
  width: 100%;

  /* suppress MUI's built-in error end-adornment icon inside the input */
  .MuiInputAdornment-root {
    display: none;
  }

  .MuiFormHelperText-root.Mui-error {
    ${fieldHelperText};
  }
`;

export const fullWidthField = css`
  @media screen and (min-width: ${theme.breaks.sm}px) {
    grid-column: 1 / -1;
  }
`;
